import { render, staticRenderFns } from "./StreamingView.vue?vue&type=template&id=3ca68133&scoped=true&"
import script from "./StreamingView.vue?vue&type=script&lang=js&"
export * from "./StreamingView.vue?vue&type=script&lang=js&"
import style0 from "./StreamingView.vue?vue&type=style&index=0&id=3ca68133&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca68133",
  null
  
)

export default component.exports